import Vue from 'vue';
import { Socket, Presence } from "phoenix"

export default {
  channels: {
    profile(context) {
      var channel = Vue.prototype.$socket.channel("profile:"+localStorage.getItem('token'));

      channel.on("init", (msg) => {
        console.log("Loaded profile", msg.account.email);
        context.commit("logged_in", true);
        context.commit("set_profile", msg);
      });

      const handlePresenceState = state => {
        const syncedPresence = Presence.syncState(context.state.profile_presence, state);
        context.commit("set_profile_presence", syncedPresence)
      }

      const handlePresenceDiff = diff => {
        const oldPresence = context.state.profile_presence;
        const syncedPresence = Presence.syncDiff(oldPresence, diff);
        context.commit("set_profile_presence", syncedPresence);
      }

      channel.on("presence_state", handlePresenceState);
      channel.on("presence_diff", handlePresenceDiff);
      Vue.Socket.socket.onMessage(({topic, event, payload}) => {
        if (event == "presence_diff" && /^profile_presence:\d+$/.test(topic)){
          handlePresenceDiff(payload)
        }
      });

      setInterval(() => {
        channel.push("ping");
      },600000);

      return channel;
    },
    groups(context) {
      var group = Vue.prototype.$socket.channel("groups:all");

      group.on("init", (msg) => {
        context.commit("set_groups", msg.groups);
      })
      group.on("update", (msg) => {
        context.commit("update_group", msg.group)
      })
      group.on("delete", (msg) => {
        context.commit("delete_group", msg.group)
      });

      return group;
    },
    channels(context) {
      var channel = Vue.prototype.$socket.channel("channels:all");

      channel.on("init", (msg) => {
        context.commit("set_channels", msg.channels);
      })
      channel.on("update", (msg) => {
        context.commit("update_channel", msg.channel)
      })
      channel.on("delete", (msg) => {
        context.commit("delete_channel", msg.channel)
      });

      return channel;
    },
    channel_templates(context) {
      var channel = Vue.prototype.$socket.channel("channels:group:all:template");

      channel.on("init", (msg) => {
        context.commit("set_channel_templates", msg.channel_groups);
      })
      channel.on("update", (msg) => {
        context.commit("update_channel_template", msg.channel_group)
      })
      channel.on("delete", (msg) => {
        context.commit("delete_channel_template", msg.channel_group)
      });

      return channel;
    },
    channel_access_groups(context) {
      var channel = Vue.prototype.$socket.channel("channels:group:all:access");

      channel.on("init", (msg) => {
        context.commit("set_channel_access_groups", msg.channel_groups);
      })
      channel.on("update", (msg) => {
        context.commit("update_channel_access_group", msg.channel_group)
      })
      channel.on("delete", (msg) => {
        context.commit("delete_channel_access_group", msg.channel_group)
      });

      return channel;
    },
    settings(context) {
      var channel = Vue.prototype.$socket.channel("settings:all");

      channel.on("init", (msg) => {
        context.commit("set_settings", msg.settings);
      })
      channel.on("update", (msg) => {
        context.commit("update_setting", msg.setting)
      })
      channel.on("delete", (msg) => {
        context.commit("delete_setting", msg.setting)
      });

      return channel;
    },
    filters(context) {
      var channel = Vue.prototype.$socket.channel("filters:all");

      channel.on("init", (msg) => {
        context.commit("set_filters", msg.filters);
      })
      channel.on("update", (msg) => {
        context.commit("update_filter", msg.filter)
      })
      channel.on("delete", (msg) => {
        context.commit("delete_filter", msg.filter)
      });

      return channel;
    },
    instances(context) {
      var channel = Vue.prototype.$socket.channel("instances:all");

      channel.on("init", (msg) => {
        console.log("Init instance", msg);
        context.commit("set_instances", msg.instances);
      });
      channel.on("update", (msg) => {
        console.log("Update instance", msg);
        context.commit("update_instance", msg.instance);
      });
      channel.on("delete", (msg) => {
        context.commit("delete_instance", msg.instance);
      });
      return channel;
    },
    devices(context) {
      var channel = Vue.prototype.$socket.channel("devices:all");

      channel.on("init", (msg) => {
        context.commit("set_devices", msg.devices);
      });
      channel.on("update", (msg) => {
        console.log("DEVICES-UPDATE", msg)
        context.commit("update_device", msg.device);
      });
      channel.on("delete", (msg) => {
        context.commit("delete_device", msg.device);
      });
      return channel;
    },
    control(context) {
      var channel = Vue.prototype.$socket.channel("control");
      channel.on("init", (msg) => {
        context.commit("set_channel_status", msg.channels);
        context.commit("set_instance_status", msg.instances);
        context.commit("set_mediaconnects_status", msg.mediaconnects)
        context.commit("set_timestamp", msg.timestamp);
      });
      channel.on("update", (msg) => {
        context.commit("set_channel_status", msg.channels);
        context.commit("set_instance_status", msg.instances);
        context.commit("set_mediaconnects_status", msg.mediaconnects);
        context.commit("set_timestamp", msg.timestamp);
      })
      return channel;
    },
    cms(context) {
      var channel = Vue.prototype.$socket.channel("cms:all");
      channel.on("init", (msg) => {
        context.commit("set_cms_list_types", msg.list_types);
        context.commit("set_cms_lists", msg.lists);
      });
      channel.on("update_list_type", (msg) => {
        context.commit("update_cms_list_type", msg.list_type);
      });
      channel.on("update_list", (msg) => {
        context.commit("update_cms_list", msg.list);
      });
      channel.on("delete_list_type", (msg) => {
        context.commit("delete_cms_list_type", msg.list_type);
      });
      channel.on("delete_list", (msg) => {
        context.commit("delete_cms_list", msg.list);
      });
      return channel;
    },
    accounts(context) {
      var channel = Vue.prototype.$socket.channel("accounts:all");
      channel.on("init", (msg) => {
        context.commit("set_accounts", msg.accounts);
      });
      channel.on("update", (msg) => {
        context.commit("update_account", msg.account);
      });
      channel.on("delete", (msg) => {
        context.commit("delete_account", msg.account);
      });
      return channel;
    },
    running_orders(context) {
      var channel = Vue.prototype.$socket.channel("running_orders:all")
      channel.on("init", (msg) => {
        context.commit("set_running_orders", msg.running_orders);
      });
      channel.on("update", (msg) => {
        context.commit("update_running_order", msg.running_order);
      });
      channel.on("delete", (msg) => {
        context.commit("delete_running_order", msg.running_order);
      });
      return channel;
    }


  },
  join_all(context) {
    for (let name in this.channels) {
      var ch = this.channels[name](context);
      console.log("Joining channel", name);
      ch.join();
      context.commit("set_websocket_channel", {name: name, channel: ch});
    }
  }
}
